// Specific channel topics for better scalability
export const INBOX_CHANNELS = {
  CONVERSATIONS: 'inbox:conversations',
  MESSAGES: 'inbox:messages',
  CONNECTIONS: 'inbox:connections',
} as const;

export const CHANNEL_DISPLAY_NAMES = {
  whatsapp_business_account: 'WhatsApp',
  web: 'Web',
} as const;

/** The chats inbox's route under an agent (`AppRouter.tsx`): `/accounts/:accountId/assistants/:AssistantID/inbox/chats`. */
export const INBOX_CHATS_PATH = 'inbox/chats';
